import { ActionBase } from './action-base';
import { type } from '../../shared/components/helpers/util';
import { Action } from '../../../lib/core/common/action';

/**
 * Menu Action Types
 */
export const MENU_ACTION = {
  LOAD: type('MENU_LOAD'),
  SET_ACTIVE: type('MENU_SET_ACTIVE'),
  SET_TOKEN: type('MENU_SET_TOKEN'),
  ENABLE_DETAIL_MENU_ITEMS: type('ENABLE_DETAIL_MENU_ITEMS'),
  ENABLE_ACCESSORIES: type('ENABLE_ACCESSORIES'),
  FEATURE_DISABLE_ACCESSORIES: type('FEATURE_DISABLE_ACCESSORIES'),
  ENABLE_PROTECTIONPRODUCTS: type('ENABLE_PROTECTIONPRODUCTS'),
  FEATURE_DISABLE_PROTECTIONPRODUCTS: type('FEATURE_DISABLE_PROTECTIONPRODUCTS'),
  FEATURE_DISABLE_LOCAL_SPECIALS: type('FEATURE_DISABLE_LOCAL_SPECIALS'),
  ENABLE_LOCAL_SPECIALS: type('MENU_ENABLE_LOCAL_SPECIALS'),
  FEATURE_DISABLE_APPLYFORCREDIT: type('FEATURE_DISABLE_APPLYFORCREDIT'),
  ENABLE_APPLYFORCREDIT: type('MENU_ENABLE_APPLYFORCREDIT')
};

/**
 * MenuActionOnLoad
 */
export class MenuActionOnLoad implements ActionBase {
  public readonly type: string = MENU_ACTION.LOAD;
  constructor(public payload: Action) {}
}

/**
 * MenuActionSetActive
 */
export class MenuActionSetActive implements ActionBase {
  public readonly type: string = MENU_ACTION.SET_ACTIVE;
  constructor(public payload: Action) {}
}

/**
 * MenuActionSetToken
 */
export class MenuActionSetToken implements ActionBase {
  public readonly type: string = MENU_ACTION.SET_TOKEN;
  constructor(public payload: string) {}
}

/**
 * MenuActionEnableDetaiMenuItems
 */
export class MenuActionEnableDetaiMenuItems implements ActionBase {
  public readonly type: string = MENU_ACTION.ENABLE_DETAIL_MENU_ITEMS;
  constructor(public payload: {}) {}
}

/**
 * MenuActionEnableAccessories
 */
export class MenuActionEnableAccessories implements ActionBase {
  public readonly type: string = MENU_ACTION.ENABLE_ACCESSORIES;
  constructor(public payload: boolean) {}
}

/**
 * MenuActionFeatureDisableAccessories
 */
export class MenuActionFeatureDisableAccessories implements ActionBase {
  public readonly type: string = MENU_ACTION.FEATURE_DISABLE_ACCESSORIES;
  constructor(public payload: boolean) {}
}

/**
 * MenuActionFeatureDisableLocalSpecials
 */
export class MenuActionFeatureDisableLocalSpecials implements ActionBase {
  public readonly type: string = MENU_ACTION.FEATURE_DISABLE_LOCAL_SPECIALS;
  constructor(public payload: boolean) {}
}

export class MenuActionEnableLocalSpecial implements ActionBase {
  public readonly type: string = MENU_ACTION.ENABLE_LOCAL_SPECIALS;
  constructor(public payload: boolean) {}
}
/**
 * MenuActionEnableAccessories
 */
export class MenuActionEnableProtectionProducts implements ActionBase {
  public readonly type: string = MENU_ACTION.ENABLE_PROTECTIONPRODUCTS;
  constructor(public payload: boolean) {}
}
/**
 * MenuActionEnableApplyForCredit
 */
export class MenuActionEnableApplyForCredit implements ActionBase {
  public readonly type: string = MENU_ACTION.ENABLE_APPLYFORCREDIT;
  constructor(public payload: boolean) {}
}

/**
 * MenuActionFeatureDisableApplyForCredit
 */
export class MenuActionFeatureDisableApplyForCredit implements ActionBase {
  public readonly type: string = MENU_ACTION.FEATURE_DISABLE_APPLYFORCREDIT;
  constructor(public payload: boolean) {}
}
/**
 * MenuActionFeatureDisableAccessories
 */
export class MenuActionFeatureDisableProtectionProducts implements ActionBase {
  public readonly type: string = MENU_ACTION.FEATURE_DISABLE_PROTECTIONPRODUCTS;
  constructor(public payload: boolean) {}
}
export type Any = MenuActionOnLoad |
MenuActionSetActive |
MenuActionSetToken |
MenuActionEnableDetaiMenuItems |
MenuActionEnableAccessories |
MenuActionFeatureDisableAccessories |
MenuActionFeatureDisableProtectionProducts |
MenuActionEnableProtectionProducts |
MenuActionFeatureDisableLocalSpecials |
MenuActionFeatureDisableApplyForCredit |
MenuActionEnableApplyForCredit;
